import { lazy } from 'react';

export const LazyFormRenderer = lazy(() => import('./FormRenderer')); // .then((m) => ({ default: m.Form }))); // () => import('@formio/react').then((m) => ({ default: m.Form })));
